export const FooterLinks = [
  {
    name: 'Ask Questions',
    url: 'https://www.hrsa.gov/about/contact/'
  },
  {
    name: 'Viewers & Players',
    url: 'https://www.hhs.gov/plugins.html'
  },
  {
    name: 'Privacy Policy',
    url: 'https://www.hhs.gov/privacy.html'
  },
  {
    name: 'Disclaimers',
    url: 'https://www.hhs.gov/disclaimer.html'
  },
  {
    name: 'Vulnerability Disclosure Policy',
    url: 'https://www.hhs.gov/vulnerability-disclosure-policy/index.html'
  },
  {
    name: 'Accessibility',
    url: 'https://www.hrsa.gov/about/508-resources.html'
  },
  {
    name: 'FOIA',
    url: 'https://www.hrsa.gov/foia/'
  },
  {
    name: 'HHS.gov',
    url: 'https://www.hhs.gov/'
  },
  {
    name: 'HRSA.gov',
    url: 'https://www.hrsa.gov/'
  },
  {
    name: 'USA.gov',
    url: 'https://www.usa.gov/'
  },
  {
    name: 'Whitehouse.gov',
    url: 'https://www.whitehouse.gov/'
  }
];
